import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { DecimalInput } from "@/components/DecimalInput";
import { Save } from "lucide-react";

export default function CalcSettings() {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = useCallback(() => { api.get("/calc-settings").then((r) => setCfg(r.data)); }, []);
  useEffect(() => { load(); }, [load]);

  if (!cfg) return null;

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/calc-settings", { hourly_rate: Number(cfg.hourly_rate) || 0 });
      toast.success("Nastavení kalkulací uloženo");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Uložení se nezdařilo");
    } finally { setSaving(false); }
  };

  return (
    <div className="fade-up">
      <PageHeader title="Nastavení kalkulací" subtitle="Výchozí hodinová sazba práce pro nové kalkulace">
        <Button onClick={save} disabled={saving} className="rounded-full" data-testid="calcsettings-save">
          <Save className="h-4 w-4 mr-2" /> Uložit
        </Button>
      </PageHeader>
      <div className="px-10 py-8 max-w-2xl space-y-6">
        <div className="bg-white border border-border rounded-xl p-8 space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground">Hodinová sazba práce (Kč / hod)</Label>
            <p className="text-xs text-muted-foreground mt-1 mb-3">Použije se jako výchozí u nových kalkulací. V každé kalkulaci lze sazbu i minuty přepsat.</p>
            <DecimalInput data-testid="calcsettings-hourly-rate" value={cfg.hourly_rate}
              onValueChange={(n) => setCfg((p) => ({ ...p, hourly_rate: n }))} className="max-w-xs" />
          </div>
        </div>
      </div>
    </div>
  );
}
